import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { PrivacyService } from '@df/module-privacy/privacy.service';

export function provideDfModulePrivacy(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(PrivacyService).appInitialize();
        })
    ]);
}
